function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.65 27.9a8.52 8.52 0 016.02-8.16 8.62 8.62 0 013.58-.34l128.8 15.16a8.6 8.6 0 017.58 8.5v81.05a8.54 8.54 0 01-8.59 8.55H9.24a8.6 8.6 0 01-8.59-8.55V27.89z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-20-13h187.83v169.45H-20.01V-13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#959DAC",
  d: "M-20 27.3h187.83v3.86H-20.01V27.3zM-20 36.24h187.83v3.88H-20.01v-3.88zM167.83 45.2H-20.01v3.87h187.84V45.2zM-20 31.77h187.83v3.87H-20.01v-3.87zM167.83 40.72H-20.01v3.88h187.84v-3.88zM-20 58.63h187.83v3.88H-20.01v-3.88zM167.83 49.68H-20.01v3.87h187.84v-3.87zM-20 67.59h187.83v3.87H-20.01v-3.87zM167.83 54.15H-20.01v3.88h187.84v-3.88zM-20 63.1h187.83V67H-20.01V63.1zM167.83 22.81H-20.01v3.87h187.84v-3.87zM167.83 18.34H-20.01v3.88h187.84v-3.88zM-20 72h187.83v3.86H-20.01V72zM-20 76.46h187.83v3.88H-20.01v-3.88zM-20 89.9h187.83v3.87H-20.01V89.9zM167.83 98.85H-20.01v3.88h187.84v-3.88zM-20 112.28h187.83v3.88H-20.01v-3.88zM-20 121.23h187.83v3.88H-20.01v-3.88zM167.83 130.2H-20.01v3.86h187.84v-3.87zM-20 116.76h187.83v3.87H-20.01v-3.87zM167.83 125.71H-20.01v3.88h187.84v-3.88zM167.83 107.8H-20.01v3.88h187.84v-3.88zM-20 94.38h187.83v3.87H-20.01v-3.87zM167.83 103.33H-20.01v3.88h187.84v-3.88zM167.83 85.42H-20.01v3.87h187.84v-3.87zM167.83 80.94H-20.01v3.88h187.84v-3.88z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M48.73 60.84a8.57 8.57 0 017.43-4.28H173.4a8.62 8.62 0 017.34 4.1 8.53 8.53 0 01.3 8.38l-30.83 59.34a8.58 8.58 0 01-7.63 4.62H21.57a8.61 8.61 0 01-7.43-4.28 8.53 8.53 0 010-8.55l34.6-59.33z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.22-14.5h187.84v169.44H3.22V-14.51z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1F487E",
  d: "M3.22 57.12h187.84V61H3.22v-3.88zM3.22 66.08h187.84v3.87H3.22v-3.87zM3.22 61.6h187.84v3.88H3.22V61.6zM3.22 70.48h187.84v3.87H3.22v-3.87zM3.22 74.95h187.84v3.88H3.22v-3.88zM3.22 88.39h187.84v3.87H3.22v-3.87zM191.06 97.34H3.22v3.88h187.84v-3.88zM3.22 110.77h187.84v3.87H3.22v-3.87zM3.22 119.72h187.84v3.88H3.22v-3.88zM191.06 128.68H3.22v3.87h187.84v-3.87zM3.22 115.25h187.84v3.87H3.22v-3.87zM191.06 124.2H3.22v3.88h187.84v-3.88zM191.06 106.3H3.22v3.87h187.84v-3.88zM3.22 92.87h187.84v3.87H3.22v-3.87zM191.06 101.82H3.22v3.88h187.84v-3.88zM191.06 83.9H3.22v3.88h187.84V83.9zM191.06 79.43H3.22v3.88h187.84v-3.88z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M122.11 24.73s.26 32.3 0 32.52l-67.49.23a7.42 7.42 0 00-6.5 3.78L31.69 90.54V7.37c0-3.79 3.34-6.85 7.43-6.85L95.94.36c.72.02 1.44.12 2.14.29m-.1-.07l23.2 23.22s.93.88.93.93h-17.1c-7.03 0-6.72-6.68-6.72-6.68m0 0s-.32-11.9-.3-17.47l.3 17.47z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 0.5,
  d: "M122.11 24.73s.26 32.3 0 32.52l-67.49.23a7.42 7.42 0 00-6.5 3.78L31.69 90.54V7.37c0-3.79 3.34-6.85 7.43-6.85L95.94.36c.72.02 1.44.12 2.14.29m24.03 24.08c0-.05-.93-.93-.93-.93L97.98.58c-.01 5.56.31 17.47.31 17.47s-.3 6.68 6.72 6.68h17.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M52.84 29.13h32.42M52.84 50.69h28.2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M85.26 50.69h15.94M89.44 29.13h11.58M51.94 40.94h13.43"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#595A5B",
  strokeLinecap: "round",
  d: "M67.7 40.94h24.88"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFE068",
  strokeLinecap: "round",
  d: "M95.14 40.94h6.83"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1738_3899"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h182v133H0z"
})));

function SvgFileFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 133,
    fill: "none",
    viewBox: "0 0 182 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1738_3899)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    width: 147,
    height: 114,
    x: 0,
    y: 19,
    maskUnits: "userSpaceOnUse"
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    width: 170,
    height: 77,
    x: 12,
    y: 56,
    maskUnits: "userSpaceOnUse"
  }, _ref4), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11), _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolder);
export default __webpack_public_path__ + "static/media/file-folder.b4e9ab3e.svg";
export { ForwardRef as ReactComponent };